import React from 'react';
import { addBreakLines } from '../../../../utils';

import './GenericDropdown.scss';

const GenericDropdown = (props) => {
  let pageRef = React.createRef();
  const { rows, color, width, doubleHeight, history } = props;

  const handleLink = (path) => {
    history.push(path);
  };

  return (
    <div
      className={`GenericDropdown ${
        doubleHeight ? 'double-height-bottom' : ''
      }`}
      style={{ backgroundColor: color, width }}
    >
      <ul>
        {rows.map((row, index) => (
          <li
            className="GenericDropdownRow"
            key={index}
            onClick={() => handleLink(row[1])}
            ref={pageRef}
          >
            {addBreakLines(row[0])}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GenericDropdown;
